import { render, staticRenderFns } from "./rain.vue?vue&type=template&id=08756422&scoped=true"
import script from "./rain.vue?vue&type=script&lang=js"
export * from "./rain.vue?vue&type=script&lang=js"
import style0 from "./rain.vue?vue&type=style&index=0&id=08756422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08756422",
  null
  
)

export default component.exports